module.exports = __webpack_public_path__ + "img/mall2.056fdee8.png";